import React, { useEffect, useRef } from "react";
import { generateAcceptanceLetter } from "../utilities/generateAcceptanceLetter";
import { FaTimes } from "react-icons/fa";
import { formatDate } from "../utilities/formatDate";

const PreviewModal = ({ isOpen, applicantDetails, onClose, onConfirm }) => {
  const pdfRef = useRef(null);

  useEffect(() => {
    if (applicantDetails) {
      const pdfUrl = generateAcceptanceLetter(applicantDetails);
      if (pdfRef.current) {
        pdfRef.current.src = pdfUrl;
      }
    }
  }, [applicantDetails]);

  return (
    isOpen && (
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50">
        <div className="bg-white rounded-lg p-4 w-[90vw] lg:w-[50vw] max-h-[90vh] overflow-y-auto shadow-lg">
          <div className="text-right">
            <button
              className="text-red-500 hover:text-red-700 font-extrabold text-xl"
              onClick={onClose}
            >
              <FaTimes />
            </button>
          </div>
          <div className="flex flex-col lg:flex-row">
            {/* PDF Preview on the left */}
            <iframe
              ref={pdfRef}
              className="w-full lg:w-[55%] h-[50vh] lg:h-[740px] mb-6 lg:mb-0"
            />

            {/* Applicant details on the right */}
            <div className="lg:w-[45%] lg:ml-4">
              <h1 className="mb-3 text-xl text-green-700 text-center underline font-bold">
                Internship Acceptance Letter Preview
              </h1>
              <p className="font-medium">
                After confirming the approval, the Acceptance letter previewed
                on the left will be sent to the internship applicant's email
                address with the following details:
              </p>
              <p className="mt-6 mb-2">Applicant Name: </p>
              <p className="text-lg uppercase font-semibold mb-4">
                {applicantDetails?.surname} {applicantDetails?.firstName}
              </p>
              <p className="mb-4">
                Phone Number: <strong>{applicantDetails?.phoneNumber}</strong>
              </p>
              <p className="mb-4">
                Nationality: <strong>{applicantDetails?.nationality}</strong>
              </p>
              <p className="mb-4">
                Department to Assign:{" "}
                <strong>{applicantDetails?.internshipDepartment}</strong>
              </p>
              <p className="mb-4">
                Supervisor to Assign:{" "}
                <strong>{applicantDetails?.internshipSupervisor}</strong>
              </p>

              <p className="mb-4">
                Internship Start:{" "}
                <strong>
                  {formatDate(applicantDetails?.internshipStartDate)}
                </strong>
              </p>
              <p className="mb-4">
                Internship End:{" "}
                <strong>
                  {formatDate(applicantDetails?.internshipEndDate)}
                </strong>
              </p>

              <div className="flex justify-center lg:justify-start gap-x-4 mt-6">
                <button
                  onClick={onConfirm}
                  className="bg-green-700 rounded-lg text-sm font-semibold p-2 px-8 text-white"
                >
                  Continue
                </button>
                <button
                  onClick={onClose}
                  className="bg-gray-600 rounded-lg text-sm font-semibold p-2 px-10 text-white"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default PreviewModal;
